import React, { type FC, memo, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { useLocation, useSearchParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { ModuleNav, type NavItem } from "./ModuleNav";

const ModuleUStVALinksImpl: FC = () => {
    const { pathname = "" } = useLocation();
    const [searchParams] = useSearchParams();

    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.UStVA + AppRoutes.UStVAOverview,
                to: AppRoutes.UStVA + AppRoutes.UStVAOverview + "?" + searchParams,
                label: <FormattedMessage id="app.titles.Vat" />,
            },
            {
                key: AppRoutes.UStVA + AppRoutes.UStVAExports,
                to: AppRoutes.UStVA + AppRoutes.UStVAExports + "?" + searchParams,
                label: <FormattedMessage id="app.titles.data_export" />,
            },
        ],
        [searchParams],
    );

    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};

export const ModuleUStVALinks = memo(ModuleUStVALinksImpl);
